import React from "react";
import { createPortal } from "react-dom";
import { FaCartShopping } from "react-icons/fa6";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../redux/hook";
import { buildCatalogPath, isCatalogPath } from "./catalogTenant";

const CHECKOUT_PATH_SUFFIXES = ["/valider-commande", "/panier"];

export default function CatalogViewCartButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const cartCount = useAppSelector((s) =>
    s.cart.cartItems?.reduce((total, item) => total + (item?.quantite ?? 0), 0) ?? 0,
  );
  const isCheckoutPage = CHECKOUT_PATH_SUFFIXES.some((suffix) =>
    location.pathname.endsWith(suffix),
  );

  if (
    typeof document === "undefined" ||
    !isCatalogPath(location.pathname) ||
    cartCount <= 0 ||
    isCheckoutPage
  ) {
    return null;
  }

  return createPortal(
    <button
      type="button"
      className="footer__cart-btn catalog-view-cart-btn"
      aria-label={`Voir le panier (${cartCount} article${cartCount > 1 ? "s" : ""})`}
      onClick={() => navigate(buildCatalogPath("/valider-commande"))}
    >
      <span className="footer__cart-count">{cartCount}</span>
      <FaCartShopping size={20} aria-hidden />
      <span>Voir le panier</span>
    </button>,
    document.body,
  );
}
